<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import TournamentResults from './TournamentResults.vue';

interface Props {
  eventId: number;
  isVisible: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();

const closeModal = () => {
  emit('close');
};
</script>

<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h2>{{ t('tournament.results.title') }}</h2>
        <button class="close-button" @click="closeModal">
          <i class="bi bi-x"></i>
        </button>
      </div>

      <div class="modal-body">
        <TournamentResults :event-id="eventId" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background-color: #efd8b0;
  border-radius: 8px;
  border: 1px solid #bd9c65;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #bd9c65;
  background-color: #c29c58;
  color: #60451f;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  color: #60451f;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(96, 69, 31, 0.1);
  }
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

// Override the tournament-results styling for modal context
:deep(.tournament-results) {
  background-color: transparent;
  border: none;
  padding: 20px;
}

:deep(.tournament-results h3) {
  display: none; // Hide the title since we have it in the modal header
}
</style>
